export enum PrintParamType {
  ObjectNumber = "objectNumber",
  EventId = "eventId"
}

export enum ObjectType {
  SalesOrder = "sales-orders",
  ServiceTicket = "tickets"
}
